module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/c3-6a677d9a542e6b451a5a660402c84b16.png";